module.exports = __webpack_public_path__ + "static/media/hand-shake.0da93ddb.svg";